// Actions for tracking current page context and support click origin
export const PAGE_CONTEXT_SET_CURRENT = "PAGE_CONTEXT/SET_CURRENT_PAGE";
export const PAGE_CONTEXT_SET_SUPPORT_ORIGIN = "PAGE_CONTEXT/SET_SUPPORT_ORIGIN";

export const setCurrentPage = ({ id, route, meta }) => ({
  type: PAGE_CONTEXT_SET_CURRENT,
  payload: { id, route, meta },
});

// note is optional, can be used to pass any additional info about click
export const setSupportOrigin = (note) => (dispatch, getState) => {
  const state = getState();
  const ctx = state.pageContext || {};
  const user = state.user || {};
  const createNewCompany = state.createNewCompany || {};
  
  // Определяем ID кампании или ID клиента
  let entityId = null;
  let entityType = null;
  
  // Проверяем, есть ли ID кампании (для редактирования/создания)
  if (createNewCompany.id && createNewCompany.id !== "") {
    entityId = createNewCompany.id;
    entityType = "campaign";
  }
  // Если нет ID кампании, берем ID клиента (кроме страниц регистрации/входа)
  else if (user.userInfo?.id && ![21, 22].includes(ctx.currentPageId)) {
    entityId = user.userInfo.id;
    entityType = "client";
  }
  
  const payload = {
    pageId: ctx.currentPageId || null,
    pageName: ctx.currentPageName || "",
    route: ctx.route || "",
    meta: ctx.meta || {},
    note: note || null,
    entityId: entityId,
    entityType: entityType,
    triggeredAt: Date.now(),
  };

  dispatch({
    type: PAGE_CONTEXT_SET_SUPPORT_ORIGIN,
    payload,
  });

  // Возвращаем payload для немедленного использования в компонентах (логирование и т.п.)
  return payload;
};


